<div class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center">
  <div class="bg-white rounded-2xl max-h-[90vh] w-[560px] xl:w-[700px] 2xl:w-[800px] 3xl:w-[950px] flex flex-col overflow-hidden">

    <div class="flex-none flex items-center justify-end px-3 pt-3 xl:px-4 xl:pt-4 3xl:px-5 3xl:pt-5">
      <button (click)="onCloseModal(false)">
        <svg
          class="mr-[7px] w-4 h-4 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 3xl:w-7 3xl:h-7 cursor-pointer"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#141F58"
          />
        </svg>
      </button>
    </div>

    <div class="flex-none px-5 pb-3 xl:px-6 xl:pb-4 2xl:px-8 2xl:pb-4 3xl:px-10 3xl:pb-5">
      <p class="text-dimot-1 text-[0.55rem] xl:text-[0.62rem] 2xl:text-[0.75rem] 3xl:text-[0.85rem] leading-relaxed text-start">
In questa Merged Heatmap mostriamo i risultati di Apertura in Economia, con l'aggiunta dei risultati di Apertura Ospedaliera per le cinque regioni italiane in cui la possibilità di acquisto in economia non è possibile: Valle d'Aosta, Piemonte, Toscana, Lazio e Sicilia.
      </p>
    </div>

    <!-- Heatmap -->
    <div class="flex-1 flex justify-center items-center px-5 pb-5 xl:px-6 xl:pb-6 2xl:px-8 2xl:pb-8 3xl:px-10 3xl:pb-10 min-h-[320px] xl:min-h-[360px] 2xl:min-h-[460px] 3xl:min-h-[540px]">

      <!-- spinner -->
      <div *ngIf="isLoading" class="flex w-full h-[320px] xl:h-[360px] 2xl:h-[460px] 3xl:h-[540px] justify-center items-center">
        <svg
          aria-hidden="true"
          class="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#141F58] items-center justify-center mx-auto"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
      </div>

      <div *ngIf="!isLoading" class="relative overflow-hidden w-full h-[320px] xl:h-[360px] 2xl:h-[460px] 3xl:h-[540px] max-w-[380px] xl:max-w-[440px] 2xl:max-w-[560px] 3xl:max-w-[660px]">
        <ejs-maps
          id="ht-merged-container"
          style="display: block"
          [width]="mapWidth"
          [height]="mapHeight"
          [layers]="layers"
        ></ejs-maps>

        <div class="absolute bottom-4 inset-x-0 mx-auto w-[75%] px-5 xl:px-6 2xl:px-8 3xl:px-10">
          <div class="flex justify-between text-[0.42rem] xl:text-[0.5rem] 2xl:text-[0.6rem] 3xl:text-[0.64rem] leading-none relative bottom-2">
            <span class="min-label">0%</span>
            <span class="max-label">100%</span>
          </div>
          <div class="gradient-bar w-full h-1.5 3xl:h-2 rounded-full mt-0.5">
            <div
              class="gradient-fill w-full h-full rounded-full"
              [style.background]="getGradientBackground()"
            ></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>